import { AxiosInstance, AxiosError } from 'axios';
import { DefaultApiFactory } from '@/repository/manager/facility/openapi/generated';
import { ErrorPresenter } from '@/repository/errorPresenter/types';
import { ChildrenRepository } from '@/service/daily/getChild';

export default function (axios: AxiosInstance) {
  const api = DefaultApiFactory(undefined, '/facility-api/v1', axios);
  return (errorPresenter: ErrorPresenter, isSupervisorMode: () => boolean): ChildrenRepository => ({
    get: async (childId: number) => {
      try {
        return (isSupervisorMode() ? await api.supervisorChildrenIdGet(childId) : await api.childrenIdGet(childId))
          .data;
      } catch (e: unknown) {
        const err = e as AxiosError;
        errorPresenter({ status: err.response?.status, error: err, requestUrl: err.config?.url });
        throw err;
      }
    },
  });
}
